// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1lh6t","button":"Footer_button__3FV5Y"};